export default __webpack_public_path__ + "static/media/retiro_seclantas6.cf3697c3.jpg";